import React from 'react'
import {
  LoaderSwitcher,
  MerchantCategoriesLoader,
  MerchantLocationsLoader
} from 'router/Loaders'
import Loyalty from 'components/Loyalty'

export const LoyaltyWrapper = () => {
  return (
    <MerchantCategoriesLoader>
      {(isParentLoaded) => (
        <MerchantLocationsLoader isParentLoaded={isParentLoaded}>
          {(isParentLoaded) => (
            <LoaderSwitcher isParentLoaded={isParentLoaded}>
              <Loyalty />
            </LoaderSwitcher>
          )}
        </MerchantLocationsLoader>
      )}
    </MerchantCategoriesLoader>
  )
}
